import Vue from 'vue'
import Notifications from 'vue-notification'
Vue.use(Notifications)

/*
MessageService
  用來顯示提示訊息，可設定「標題」與「內容」
*/
const MessageService = {

    showError(title,message){
        window.vm.$notify({
            group : 'foo',
            title : title,
            text : message,
            type: 'error'
        });
    },
    showSuccess(title,message){
        window.vm.$notify({
            group: 'foo',
            title: title,
            text: message,
            type: 'success',
          });
    },
    showInfo(title,message){
        var defaultTitle = "系統訊息";
        Vue.notify({
            group : 'foo',
            title : (title || defaultTitle),
            text : message,
            type: 'info'
        });
    },
    showSystemError(){
        Vue.notify({
            group : 'foo',
            title : '系統錯誤',
            text : '系統發生錯誤，請洽系統管理員',
            type: 'warning'
        });
    }
}

export default MessageService;


// WEBPACK FOOTER //
// ./src/util/messageService.js